export const products = [
  {
    id: 1,
    name: "Monstera Deliciosa",
    price: 45,
    image: "https://images.unsplash.com/photo-1614594975525-e45190c55d40?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    category: "plant",
    lightLevel: "Bright Indirect",
    difficulty: "Medium",
    description: "The classic Swiss Cheese plant. Famous for its dramatic, fenestrated leaves. A fast grower that will quickly become the centerpiece of your room.",
    reviews: 124,
    rating: 4.8
  },
  {
    id: 2,
    name: "Snake Plant Laurentii",
    price: 28,
    image: "https://images.unsplash.com/photo-1593482892290-f54927ae2b7e?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    category: "plant",
    lightLevel: "Low",
    difficulty: "Easy",
    description: "Nearly indestructible. The Snake Plant thrives on neglect and is perfect for low-light corners and beginners.",
    reviews: 89,
    rating: 4.9
  },
  {
    id: 3,
    name: "Fiddle Leaf Fig",
    price: 65,
    image: "https://images.unsplash.com/photo-1597055905081-8cb4275cd3e2?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    category: "plant",
    lightLevel: "Bright Indirect",
    difficulty: "Hard",
    description: "A stunning statement plant with large, violin-shaped leaves. Requires a consistent watering schedule and bright, filtered light.",
    reviews: 56,
    rating: 4.2
  },
  {
    id: 4,
    name: "ZZ Plant",
    price: 32,
    image: "https://images.unsplash.com/photo-1632207691143-643e2a9a9361?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    category: "plant",
    lightLevel: "Low",
    difficulty: "Easy",
    description: "With its glossy, dark green leaves, the ZZ Plant is elegant and incredibly resilient. Drought-tolerant and low-light friendly.",
    reviews: 210,
    rating: 5.0
  },
  {
    id: 5,
    name: "Beginner Oasis Bundle",
    price: 75,
    image: "https://images.unsplash.com/photo-1416879598555-220b33b00085?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    category: "bundle",
    lightLevel: "Any",
    difficulty: "Easy",
    description: "Start your jungle with confidence. Includes a Snake Plant, ZZ Plant, and Golden Pothos—the holy trinity of unkillable houseplants.",
    reviews: 45,
    rating: 4.9
  },
  {
    id: 6,
    name: "Terracotta Clay Pot - 8\"",
    price: 18,
    image: "https://images.unsplash.com/photo-1485955900006-10f4d324d411?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    category: "accessory",
    lightLevel: "N/A",
    difficulty: "N/A",
    description: "Classic, breathable terracotta. Perfect for plants that prefer their soil to dry out between waterings.",
    reviews: 32,
    rating: 4.7
  },
  {
    id: 7,
    name: "Bird of Paradise",
    price: 85,
    image: "https://images.unsplash.com/photo-1611211232932-da3113c5b960?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    category: "plant",
    lightLevel: "Direct",
    difficulty: "Medium",
    description: "Bring the tropics indoors. Features massive, banana-like leaves and can grow impressively tall given enough sunlight.",
    reviews: 18,
    rating: 4.5
  },
  {
    id: 8,
    name: "Brass Plant Mister",
    price: 24,
    image: "https://images.unsplash.com/photo-1592150621744-aca64f48394a?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    category: "accessory",
    lightLevel: "N/A",
    difficulty: "N/A",
    description: "Keep your humidity-loving plants happy in style with this elegant vintage-style brass mister.",
    reviews: 67,
    rating: 4.6
  }
];